"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLocationMessage = exports.LocationDropdownAddressContainer = exports.LocationDropdownContainer = exports.StyledButton = exports.StyledMenuItem = exports.StyledMenu = exports.StyledLabel = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const menu_1 = __importStar(require("@kyruus/menu"));
const button_1 = __importDefault(require("@kyruus/button"));
const provider_1 = require("../../../lib/constants/provider");
exports.StyledLabel = (0, styled_1.default)('p') `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: 0;
`;
exports.StyledMenu = (0, styled_1.default)(menu_1.default) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: ${({ anchorEl }) => (anchorEl ? `${anchorEl.clientWidth}px` : '0')};

  div.MuiPaper-root {
    width: inherit;
    min-width: inherit;
    max-width: inherit;
    max-height: ${provider_1.LOCATIONS_DROPDOWN_MAX_HEIGHT}px;
    overflow-y: auto;
  }

  ul {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  ul > li {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    padding-top: calc(${(0, ui_theme_1.fromTheme)('spacing_large')} / 2);
    padding-bottom: calc(${(0, ui_theme_1.fromTheme)('spacing_large')} / 2);
    white-space: wrap;
  }

  ul > li:first-child {
    padding-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  ul > li:last-child {
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.StyledMenuItem = (0, styled_1.default)(menu_1.MenuItem) `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  align-items: flex-start;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  padding: 0;

  &:hover {
    background: ${(0, ui_theme_1.fromTheme)('color_background_hover')} !important;
  }

  > div {
    gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    display: flex;
    label {
      width: 100%;
      // Align checkbox with location name
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      margin-top: 3px;
      span {
        margin-top: 3px;
      }
      .checkmark {
        min-width: 14px;
      }
    }

    h5 {
      text-indent: 0px;
      font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      margin: 0;
      padding: 0;
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    }
  }

  > div.NonBookableLocation {
    > div {
      gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      display: flex;
      svg {
        margin-right: 0px;
      }
    }
  }
`;
exports.StyledButton = (0, styled_1.default)(button_1.default) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 37px;

  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  background: ${(0, ui_theme_1.fromTheme)('color_background')};

  &:hover {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    outline: none;
  }

  &:active {
    background: transparent;
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    color: ${(0, ui_theme_1.fromTheme)('text_color')};
  }

  &:active:not(:disabled) {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    background: transparent;
  }

  &:focus {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
  }
`;
exports.LocationDropdownContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.LocationDropdownAddressContainer = styled_1.default.p `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: 0;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  text-indent: 0px;
`;
exports.StyledLocationMessage = styled_1.default.div `
  background-color: none;
  border: none;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  display: flex;
  align-items: flex-end;
  gap: 0;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
//# sourceMappingURL=styles.js.map